// src/lib/format.ts
const CURRENCY = "ر.س";

/** أرقام بالصيغة اللاتينية كما في التصميم (45,000). */
export const fmt = (n: number | string | null | undefined): string =>
  n === null || n === undefined || n === "" ? "—" : Number(n).toLocaleString("en-US");

export const fmtMoney = (n: number | string | null | undefined): string =>
  n === null || n === undefined ? "—" : `${Number(n).toLocaleString("en-US", { maximumFractionDigits: 2 })} ${CURRENCY}`;

export const fmtPct = (n: number | null | undefined, digits = 1): string =>
  n === null || n === undefined ? "—" : `${Number(n).toFixed(digits).replace(/\.0+$/, "")}%`;

export const fmtDate = (iso: string | null | undefined): string => (iso ? iso.slice(0, 10) : "—");

export const fmtDateTime = (iso: string | null | undefined): string =>
  iso ? `${iso.slice(0, 10)} ${iso.slice(11, 16)}` : "—";

/** "قبل ساعتين" / "قبل 3 أيام" — تقريب مناسب لشاشات المراقبة. */
export function fromNow(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "—";
  const diff = Math.max(0, now - new Date(iso).getTime());
  const min = Math.floor(diff / 60_000);
  if (min < 1) return "الآن";
  if (min < 60) return min === 1 ? "قبل دقيقة" : `قبل ${min} دقيقة`;
  const h = Math.floor(min / 60);
  if (h < 24) return h === 2 ? "قبل ساعتين" : `قبل ${h} ساعة`;
  const d = Math.floor(h / 24);
  return d === 1 ? "أمس" : d === 2 ? "قبل يومين" : `قبل ${d} أيام`;
}

/** الوقت المتبقي/المتجاوز حتى موعد معيّن: {label, overdue}. */
export function countdown(iso: string | null | undefined, now = Date.now()): { label: string; overdue: boolean } | null {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - now;
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3_600_000);
  const text = h >= 48 ? `${Math.floor(h / 24)} أيام` : h >= 1 ? `${h} س` : `${Math.max(1, Math.floor(abs / 60_000))} د`;
  return ms < 0 ? { label: `متأخر ${text}`, overdue: true } : { label: `يتبقى ${text}`, overdue: false };
}

export const shortId = (id: string): string => id.slice(0, 8);
